<div class="white container-fluid">
    <div class="lock-screen">
        <div class="animate fadeIn text-center">
            <div class="col-md-12 p-0 row">
                <div class="col-md-9 blue-seprator">
                    <img src="assets/images/RCM_1.jpg" class="img-fluid">
                </div>
                <div class="col-md-3 p-0 bottom-align">
                    <div class="col-md-12">
                        <div class="col-md-12 mb-10 p-0 row justify-content-lg-center">
                          <ng-container *ngIf="!isCurrance;else isCurranceLogo">
                            <span class="col-md-6 pl-0" *ngIf="!loginservice.isHideGebbsLogo">
                                <!-- <div class="logo-w"> -->
                                <img src="assets/images/logo_156.png" class="img-fluid">
                                <!-- </div> -->
                            </span>
                            <span [ngClass]="{'blue-seprator-l' : loginservice && !loginservice.isHideGebbsLogo}" class="col-md-6 pr-0">
                                <!-- <div class="logo-i"> -->
                                <img src="assets/images/iAR.png" class="imgLogo img-fluid img-100">
                                <!-- </div> -->
                            </span>
                          </ng-container>

                          <ng-template #isCurranceLogo>
                            <span class="col-md-12">
                              <div>
                                  <!-- replaced 'img-responsive' class with 'img-fluid' -->
                                  <img src="assets/images/iAR_Login.png" class="img-fluid img-100">
                              </div>
                            </span>
                          </ng-template>
                        </div>
                        <div class="col-md-12 text-center version-text" style="margin-top: 6px;"> Version: {{version}}.0</div>
                    </div>
                    <div *ngIf="!SwitchToReset" class="col-md-12">
                        <div class="col-md-12 p-0">
                            <div class="heading-panel sT-hight p-0">
                                <span class="title-border text-sm text-ellipsis heading-txt blue-text h-height">
                                    Reset Password?
                                </span>
                            </div>
                        </div>
                        <div class="col-md-12 opc p-0 text-left mb-10">
                            Please enter User Name. Instructions will be sent to change your password
                        </div>
                    </div>
                    <!-- <div *ngIf="SwitchToReset" class="col-md-12">
                        <div class="col-md-12 p-0">
                            <div class="heading-panel sT-hight p-0">
                                <span
                                    class="text-sm text-ellipsis heading-txt blue-text h-height title-border">Temporary
                                    Password</span>
                            </div>
                        </div>
                    </div> -->
                    <form *ngIf="SwitchToReset" [formGroup]="ResetForm" (ngSubmit)="ResetPassword()">
                        <!-- <div class="col-md-12 mt-10">
                            <div class="form-group">
                                <label for="temppass" class="label-std control-label p-0 b-600">Temporary
                                    Password</label>
                                <input minlength="5" maxlength="5" type="text" autocomplete="off" class="form-control"
                                    formControlName="Temporary_Password" name="Temporary_Password" id="temppass"
                                    placeholder="Temporary Password" value="">
                                <div class="error"
                                    *ngIf="ResetForm.get('Temporary_Password').hasError('required') && DisplayError">
                                    Temporary Password is required.
                                </div>
                                <div class="error"
                                    *ngIf="!ResetForm.controls['Temporary_Password'].valid && ResetForm.controls['Temporary_Password'].dirty">
                                    Temporary Password should be of 5 characters only
                                </div>
                            </div>
                        </div> -->
                        <div class="col-md-12 ">
                            <div class="form-group">
                                <label for="newpass" class="label-std control-label p-0 b-600">New Password</label>
                                <input [minlength]="emailMinLength" [maxlength]="emailMaxLength" type="password" autocomplete="off" class="form-control" formControlName="New_Password" id="newpass" placeholder="New Password" value="">
                                <div class="error"
                                    *ngIf="ResetForm.get('New_Password').hasError('required') && DisplayError">
                                    New Password is required.
                                </div>
                                <div class="error" *ngIf="ResetForm.controls['New_Password'].hasError('pattern') && ResetForm.controls['New_Password'].dirty">
                                    New Password should be of {{emailMinLength}} to {{emailMaxLength}} characters and must contain 1 capital,1 small,1 special and 1 digit character
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 ">
                            <div class="form-group">
                                <label for="confirmnewpass" class="label-std control-label p-0 b-600">Confirm New
                                    Password</label>
                                <input [minlength]="emailMinLength" [maxlength]="emailMaxLength" type="password" class="form-control" id="confirmnewpass" formControlName="confirmnewpass" placeholder="Confirm New Password" value="">
                                <div class="error" *ngIf="ResetForm.get('confirmnewpass').hasError('required') && DisplayError">
                                    Please Confirm New Password
                                </div>
                                <div class="error"
                                *ngIf="ResetForm.get('New_Password').hasError('required') && DisplayError">
                                Confirm New Password is required.
                            </div>
                                <div class="error" *ngIf="ResetForm.get('confirmnewpass').hasError('notMatch') && ResetForm.controls['confirmnewpass'].dirty">
                                    New Password and Confirm Password do not match
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-10" *ngIf="ResetForm.controls.captchaData as captcha">
                            <div class="form-group" style="margin-bottom:0">
                                <div class="captchaContainer">
                                  <img [src]="showCaptcha" alt="captcha" style="height: 50px;width: 200px;">
                                    <div class="controls">
                                        <div class="inputCtrl">
                                            <input class="valid" formControlName="captchaData" type="text" placeholder="Type above text">
                                            <span class="errorSection" *ngIf="captcha.touched==true || DisplayError">
                                                <div class="error"
                                                *ngIf="ResetForm.get('captchaData').hasError('required') && DisplayError">
                                                    Captcha is required.
                                                </div>
                                                <div class="error"
                                                    *ngIf="captcha.errors && captcha.errors.invalidCaptcha">
                                                    Please type valid Captcha
                                                </div>
                                            </span>
                                        </div>
                                        <button title="Refresh Captcha Code" type="button" class="btn btn-primary" (click)="callCaptcha()">
                                          <i [ngClass]="{'rotate': isCaptcha == true}" class="fa fa-refresh"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-10 text-center">
                            <button type="submit" [disabled]="DisableSubmit" class="btn blue square-btn blue-hover btn-txt btn-default">Submit</button>
                        </div>
                    </form>
                    <div *ngIf="!loginservice.isHideGebbsLogo" class="col-md-12 mt-15 text-center copy-text">
                        <span>Copyright &copy; {{CurrentYear}} GeBBS Healthcare Solutions</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-12 text-center">
      <p>
        <b>Security Notice:</b> You are using a secure web connection. Your password will be encrypted in transit to our web server, but will remain on your
        browser until you exit it.
        </p>
          <b>
              UNAUTHORIZED ACCESS TO THIS SERVICE IS PROHIBITED.<br />
          </b>
          <p>iAR is confidential and proprietary, and is for authorized users only. All authorized users are subject to
              contractual use restrictions and nondisclosure requirements that prevent giving access to third parties.
              Unauthorized users are subject to prosecution, lawsuits, and penalties under state and federal law. All
              system activities are monitored, recorded and reviewed by system personnel. Anyone using this system
              expressly consents to such monitoring and is hereby warned that if such monitoring reveals possible evidence
              of criminal activity by the user, the same shall be reported to law enforcement Agency. Provider reserves
              the right, at its sole discretion, to change, modify the software or program at any time without notice. Any
              rights not expressly granted herein are reserved.
          </p>
          <p>
            Contact: Infosec Team - infosec@gebbs.com
          </p>
    </div>
</div>
